type Question = {
  subject: string;
  choices?: string[];
  remarks?: string[];
};

export const questions: Question[] = [
  {
    subject: "本薬局のご利用ははじめてですか？",
    choices: ["はい、はじめてです", "いいえ、以前利用したことがあります"],
  },
  {
    subject:
      "この医療機関が発行する処方箋を本薬局に提出いただくのははじめてですか？",
    choices: ["はい、はじめてです", "いいえ、過去に持ち込んだことがあります"],
  },
  {
    subject: "ジェネリック医薬品を希望されますか？",
    choices: ["希望する", "希望しない", "特に希望がないので薬局にまかせる"],
    remarks: [
      "ジェネリック医薬品は新薬（先発医薬品）と同じ有効成分を含み、品質・効き目・安全性が同等と国に認められた低価格のお薬です",
      "2024年10月1日以降、ジェネリック医薬品があるお薬で新薬を希望されると、国が定める特別の料金がかかることがあります。詳細は薬局へご相談ください",
    ],
  },
  {
    subject: "お薬手帳をお持ちですか？",
    choices: [
      "紙の手帳があり、薬剤情報のシールを希望",
      "電子お薬手帳があり、QRコードを希望",
      "お薬手帳を持っていない",
      "お薬手帳は利用しない",
    ],
  },
  {
    subject: "薬局・薬剤師にお伝えしたいことがございましたら、ご記入ください",
  },
];
